const OPCS_411_CUTOFF = "2026-04-01T00:00:00Z";

export type OpcsVersion = 10 | 11;

export function getOpcsVersionForDate(dischargeDatetime: string | undefined): OpcsVersion {
  if (!dischargeDatetime) return 10;
  return new Date(dischargeDatetime) >= new Date(OPCS_411_CUTOFF) ? 11 : 10;
}

export function getOpcsVersionLabel(version: OpcsVersion): string {
  return `OPCS-4.${version}`;
}
